import React, { Component } from 'react'
import axios from 'axios';
import Layout from './Layout';
import { Table, Button, Breadcrumb, message, Popconfirm, Tag } from 'antd';
import { Link } from 'react-router-dom';
import { adminRoutes } from '../helpers/adminRoutes';
import { getHeaderWithToken } from '../helpers/func';
import { SERVER_URL } from '../api';

class SproutsRoundList extends Component {

    constructor(props) {
        super(props)
        this.state = {
            rounds: [],
            loading: true,
        }
    }

    componentDidMount() {
        this.load();
    }

    load = () => {
        this.setState({ loading: true });
        axios({
            method: 'GET',
            url: `${SERVER_URL}v1/sprouts-round`,
            headers: getHeaderWithToken(),
        }).then((response) => {
            this.setState({ rounds: response.data.data || [], loading: false });
        }).catch(() => {
            this.setState({ loading: false });
            message.error('Failed to load Sprouts rounds.');
        });
    }

    handleDelete = (id) => {
        axios({
            method: 'DELETE',
            url: `${SERVER_URL}v1/sprouts-round/${id}`,
            headers: getHeaderWithToken(),
        }).then(() => {
            message.success('Round deleted.');
            this.load();
        }).catch(() => {
            message.error('Failed to delete round.');
        });
    }

    render() {
        let { rounds, loading } = this.state;

        const columns = [
            {
                title: 'Round',
                dataIndex: 'round_label',
                key: 'round_label',
            },
            {
                title: 'Status',
                dataIndex: 'enabled',
                key: 'enabled',
                render: (val) => val ? <Tag color="green">Enabled</Tag> : <Tag>Disabled</Tag>,
            },
            {
                title: 'Items',
                dataIndex: 'item_variant_ids',
                key: 'items',
                render: (val) => (val || []).length,
            },
            {
                title: 'Deadline',
                dataIndex: 'deadline',
                key: 'deadline',
                render: (val) => val ? new Date(val).toLocaleString() : '—',
            },
            {
                title: '',
                key: 'actions',
                render: (_, round) => (
                    <div className="d-flex">
                        <Link to={`${adminRoutes.EDITSPROUTSROUND}/${round._id}`}>
                            <Button>Edit</Button>
                        </Link>
                        <Popconfirm
                            title="Are you sure you want to delete this round?"
                            onConfirm={() => this.handleDelete(round._id)}
                            okText="Yes"
                            cancelText="No"
                        >
                            <Button style={{ marginLeft: 8 }}>Delete</Button>
                        </Popconfirm>
                    </div>
                ),
            },
        ];

        return (
            <Layout>
                <div className="content-box supplies-page">
                    <div className="bredcrumb-div">
                        <Breadcrumb separator="-">
                            <Breadcrumb.Item><span>Sprouts Rounds</span></Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                    <div className="page-title d-flex">
                        <h2>Sprouts Rounds</h2>
                        <Link to={adminRoutes.ADDSPROUTSROUND}>
                            <Button type="primary" className="primary-btn" style={{ minWidth: 170 }}> ADD ROUND </Button>
                        </Link>
                    </div>
                    <div className="page-content">
                        <Table
                            rowKey="_id"
                            dataSource={rounds}
                            columns={columns}
                            loading={loading}
                            pagination={false}
                        />
                    </div>
                </div>
            </Layout>
        )
    }
}

export default SproutsRoundList;
